export const noopMutationRunner = async () => {
  throw new Error("Chat data mutation is not implemented.");
};

export const withMutationDefaults = (mutation) => ({
  run: mutation?.run || noopMutationRunner,
  state: {
    isLoading: Boolean(mutation?.state?.isLoading),
    isError: Boolean(mutation?.state?.isError),
    error: mutation?.state?.error || null,
  },
});
